import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileCheck, AlertTriangle, MailX, Clock } from 'lucide-react';

import { QuoteDashboardSummary } from '../../services/types';

interface QuoteSummaryCardsProps {
  summary: QuoteDashboardSummary;
}

interface CardConfig {
  key: keyof Omit<QuoteDashboardSummary, 'totalQuotes'>;
  labelKey: string;
  icon: React.ElementType;
  bgColor: string;
  textColor: string;
  iconColor: string;
}

const CARD_CONFIGS: CardConfig[] = [
  {
    key: 'drafted',
    labelKey: 'quoteDashboard.summary.drafted',
    icon: FileCheck,
    bgColor: 'bg-green-50',
    textColor: 'text-green-800',
    iconColor: 'text-green-600',
  },
  {
    key: 'skipped',
    labelKey: 'quoteDashboard.summary.skipped',
    icon: AlertTriangle,
    bgColor: 'bg-yellow-50',
    textColor: 'text-yellow-800',
    iconColor: 'text-yellow-600',
  },
  {
    key: 'noThreadFound',
    labelKey: 'quoteDashboard.summary.noThread',
    icon: MailX,
    bgColor: 'bg-red-50',
    textColor: 'text-red-800',
    iconColor: 'text-red-600',
  },
  {
    key: 'notProcessed',
    labelKey: 'quoteDashboard.summary.notProcessed',
    icon: Clock,
    bgColor: 'bg-gray-50',
    textColor: 'text-gray-800',
    iconColor: 'text-gray-500',
  },
];

export const QuoteSummaryCards: React.FC<QuoteSummaryCardsProps> = ({
  summary,
}) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {CARD_CONFIGS.map((config) => {
        const Icon = config.icon;
        return (
          <div
            key={config.key}
            className={`${config.bgColor} rounded-lg p-4 border`}
          >
            <div className="flex items-center gap-3">
              <Icon className={`w-5 h-5 ${config.iconColor}`} />
              <div>
                <p className={`text-2xl font-bold ${config.textColor}`}>
                  {summary[config.key]}
                </p>
                <p className={`text-sm ${config.textColor} opacity-80`}>
                  {t(config.labelKey)}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
